module.exports = __webpack_public_path__ + "mar71logo-red.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/InvoiceManagement/Sale/SaleInvoiceDetailOfficialLayout/mar71logo-red.png
 ** module id = 1042
 ** module chunks = 0
 **/